import { Injectable } from '@angular/core'

import {
  AssessmentLevel,
  IRoleplaySoundEffect,
  SoundEffectConfig,
} from '../roleplay-assessment.types'

export const DEFAULT_SOUND_EFFECT_CONFIG: SoundEffectConfig = {
  Bad: 'assets/audio/sound-effects/bad.mp3',
  Normal: 'assets/audio/sound-effects/normal.mp3',
  Good: 'assets/audio/sound-effects/good.mp3',
  Excellent: 'assets/audio/sound-effects/excellent.mp3',
}

export const SIMPLE_SOUND_EFFECT_CONFIG: SoundEffectConfig = {
  Bad: 'assets/audio/sound-effects/simple/bad.mp3',
  Normal: 'assets/audio/sound-effects/simple/normal.mp3',
  Good: 'assets/audio/sound-effects/simple/good.mp3',
  Excellent: 'assets/audio/sound-effects/simple/excellent.mp3',
}
/**
 * SE再生サービス
 *
 * AssessmentLevelに応じた音声ファイルを第2<audio>要素で再生する。
 * AudioQueueServiceとは独立した<audio>要素を使用し、AI応答音声に影響を与えない。
 *
 * アドオンインターフェースIRoleplaySoundEffectを実装し、
 * ROLEPLAY_SOUND_EFFECT InjectionTokenで提供される。
 */
@Injectable({
  providedIn: 'root',
})
export class RoleplaySoundEffectService implements IRoleplaySoundEffect {
  private audioElement: HTMLAudioElement | null = null
  private config: SoundEffectConfig = { ...DEFAULT_SOUND_EFFECT_CONFIG }

  /**
   * SE再生に使用するHTMLAudioElementを設定する。
   * コンポーネントのngAfterViewInitで呼び出す。
   */
  init(element: HTMLAudioElement): void {
    this.audioElement = element
  }

  /**
   * 指定のassessmentに対応するSEを再生する。
   * assessmentがundefinedの場合は何もしない。
   * init()未呼び出し時はconsole.warnを出力し、即座にresolveする。
   */
  async play(assessment: AssessmentLevel | undefined): Promise<void> {
    if (assessment == null) {
      return
    }

    if (this.audioElement == null) {
      console.warn(
        'RoleplaySoundEffectService: init()が呼び出されていません。SE再生をスキップします。',
      )
      return
    }

    const filePath = this.config[assessment]
    this.audioElement.src = filePath
    this.audioElement.currentTime = 0

    try {
      await this.audioElement.play()
    } catch (error) {
      console.warn('RoleplaySoundEffectService: SE再生に失敗しました。', error)
    }
  }

  /**
   * SE設定を更新する（アドオン差し替え時に使用）。
   */
  configure(config: Partial<SoundEffectConfig>): void {
    this.config = { ...this.config, ...config }
  }
}
